export const convertToArray = object => {
  if (object) {
    return object?.length ? object : Object.values(object);
  }
};
